export enum PageType {
    HOME, PAGE, ISSUE, ISSUES, LIST, MINIMAL
}
